export default (domain, tokenStorage, libraryServicesApi) => {
    const library = {}
    const { addTokenPrefix, addApiSuffix, isOnLocalhost, addApiPrefix } = libraryServicesApi

    library.getAuthorizationHeader = () => {
        if (!isAccessToken()) {
            return null
        }

        const accessToken = tokenStorage.getAccessToken()
        return addTokenPrefix(accessToken)
    }

    const isAccessToken = () => {
        return !!tokenStorage.getAccessToken()
    }

    library.getServerDomain = () => {
        const serverURL = addApiSuffix(domain)
        return isOnLocalhost() ? serverURL : addApiPrefix(serverURL)
    }

    library.userHasntAcceptedTheTermsOfUser = (errors) => {
        return 'terms_of_use_not_accepted' in errors
    }

    library.userHasPasswordExpired = (errors) => {
        return 'password_is_expired' in errors
    }

    library.redirectToUpdatePassword = (token) => {
        window.location.href = '/v2/login/update-password/' + token
    }

    library.redirectToTermsOfUse = () => {
        window.location.href = `/v2/terms-of-use`
    }

    library.redirectToErrorPage = (errorCode) => {
        window.location.href = '/v2/pages/error/' + errorCode
    }

    return library
}
